import { ADD_FILTER_OPTIONS } from '../actions/actionTypes';

const initialState = {
    filtros: {
        optionsMaterial: [],
        optionsPermanencia: [],
        optionsMarca: [],
        optionsFabrica: [],
        optionsFabricaVersao: [],
        optionsFabricaVersaoPreparacao: [],
        optionsLinhaProduto: [],
        optionsCategoriaProduto: [],
        optionsColecao: [],
        optionsTipoProdutoAcabado: [],
        optionsDestinoConfeccao: [],
        optionsProgramacaoManual: [],
        optionsNo: [],
        observacoes: [],
        optionsNivelRisco: [],
        optionsFabricaPreparacao: [],
        optionsJustificativa: [],
        optionsCtZcos: [],
        optionsFaixaOperacional: [],
    },
};

export const filterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_FILTER_OPTIONS:
            return {
                ...state,
                filtros: {
                    ...state.filtros,
                    ...action.filtros,
                },
            };
        default:
            return state;
    }
};
